<keycom-left-bar
  [logo]="logo"
  [title]="title"
  [user]="user"
  (profileAction)="onProfileAction($event)"
  (helpAction)="onHelpAction($event)"
>
</keycom-left-bar>

<div class="app-container">
  <ng-content></ng-content>
</div>
